import {Axios} from "axios";
import {DigitalActionAuthorizationDto} from "./SubmissionApiClient";

export enum DigitalActionAuthorizationResult {
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
}

export interface DigitalActionAuthorizationInitResultDto {
    digitalActionId: string;
    result: DigitalActionAuthorizationResult;
    postInitRedirectUri?: string | null;
}

export interface DigitalActionAuthorizationMockedResultDto {
    digitalActionId: string;
    result?: DigitalActionAuthorizationResult;
    errorCode?: string;
    simulateTemporaryError: boolean;
}

export interface DigitalActionAuthorizationCompletionResultDto {
    submissionId: number;
    digitalActionAuthorization: DigitalActionAuthorizationDto;
}

export class SubmissionAuthorizationApiClient {

    constructor(private readonly axios: Axios) {
    }

    initDigitalActionAuthorization(submissionId: string): Promise<DigitalActionAuthorizationInitResultDto | undefined> {
        return new Promise((resolve, reject) => {
            this.axios.post<DigitalActionAuthorizationInitResultDto | undefined>(`/submissions/${submissionId}:init-digital-action-authorization`)
                .then((response) => resolve(response.data))
                .catch((error) => {
                    if (error?.response?.status === 404) {
                        resolve(undefined);
                        return;
                    }
                    reject(error);
                });
        });
    }

    reinitDigitalActionAuthorization(submissionId: string): Promise<DigitalActionAuthorizationInitResultDto | undefined> {
        return new Promise((resolve, reject) => {
            this.axios.post<DigitalActionAuthorizationInitResultDto | undefined>(`/submissions/${submissionId}:reinit-digital-action-authorization`)
                .then((response) => resolve(response.data))
                .catch((error) => {
                    if (error?.response?.status === 404) {
                        resolve(undefined);
                        return;
                    }
                    reject(error);
                });
        });
    }

    setDigitalActionAuthorizationMockedResult(submissionId: string, mockedResult: DigitalActionAuthorizationMockedResultDto): Promise<void> {
        return new Promise((resolve, reject) => {
            this.axios.post<void>(`/submissions/${submissionId}:set-digital-action-authorization-mocked-result`, mockedResult)
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    simulateDigitalActionAuthorizationStartupOutage(simulate: boolean): Promise<void> {
        return new Promise((resolve, reject) => {
            this.axios.post<void>(`/submissions:simulate-digital-action-authorization-startup-outage`, null, {params: {simulate}})
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    completeDigitalActionAuthorization(digitalActionId: string, result: string, errorCode: string | null): Promise<DigitalActionAuthorizationCompletionResultDto | undefined> {
        return new Promise((resolve, reject) => {
            this.axios.post<DigitalActionAuthorizationCompletionResultDto | undefined>(`/submissions/digital-actions/${digitalActionId}:complete-digital-action-authorization`, {
                resultCode: result,
                errorCode: errorCode
            })
                .then((response) => resolve(response.data))
                .catch((error) => {
                    if (error?.response?.status === 404) {
                        resolve(undefined);
                        return;
                    }
                    reject(error);
                });
        });
    }

}
